import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 800px;
`;

export const DashboardPanel = styled.div`
  background-color: #fff;
  padding-bottom: 10px;
`;

export const Header = styled.header`
  background-color: #fff;
  padding: 10px;
`;
